export default "https://fiverr-res.cloudinary.com/npm-assets/@fiverr/search_perseus/apps/room.ce76ab2.svg";